import { User } from '@api/model/user';
import { WhiteLabel } from '@api/model/white-label';
import { Condo } from '@api/model/condo';

export enum NotificationChannel {
  WEB = 'WEB',
  PUSH = 'PUSH',
  WEB_AND_PUSH = 'WEB_AND_PUSH'
}

export const NotificationChannelLabelMap: Record<NotificationChannel, string> = {
  [NotificationChannel.WEB]: 'Web',
  [NotificationChannel.PUSH]: 'Push',
  [NotificationChannel.WEB_AND_PUSH]: 'Web e Push'
};

export enum UserType {
  USER = 'USER',
  JANITOR = 'JANITOR',
  GATEKEEPER = 'GATEKEEPER',
  ADMIN = 'ADMIN',
  OWNER = 'OWNER'
}

export enum UserTypeLabel {
  USER = 'Condômino',
  JANITOR = 'Zelador',
  GATEKEEPER = 'Porteiro',
  ADMIN = 'Administrador',
  OWNER = 'Síndico'
}

export enum CondoType {
  HOUSE = 'HOUSE',
  APARTMENT = 'APARTMENT',
  BUSINESS = 'BUSINESS',
  OTHER = 'OTHER'
}

export enum CondoTypeLabel {
  HOUSE = 'Casa',
  APARTMENT = 'Apartamento',
  BUSINESS = 'Comercial',
  OTHER = 'Outro'
}

export interface SystemBroadcast {
  _id: string;
  title: string;
  message: string;
  htmlMessage: string;
  createdAt: string;
  isActive: boolean;
  createdBy: User;
  notificationChannel?: NotificationChannel;
  link?: string;
  linkButtonName?: string;
  whiteLabels?: WhiteLabel[];
  condos?: Condo[];
  userTypes: UserType[];
  condoTypes: CondoType[];
  startDate: string;
  endDate: string;
  linkButtonClickCount?: number;
}
